/**
 * Runs `task` once the page has finished loading and the browser is idle
 * (ALU-663). Used to start third-party SDKs (PostHog, Sentry) without making
 * them compete with hydration. `timeout` caps the wait for an idle moment so
 * a busy page still starts them. Does nothing on the server.
 */
export function runAfterLoadIdle(task: () => void, timeout = 3000): void {
  if (typeof window === 'undefined') return
  const idle = () => {
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
    }
    if (typeof w.requestIdleCallback === 'function') w.requestIdleCallback(task, { timeout })
    else window.setTimeout(task, 200)
  }
  if (document.readyState === 'complete') idle()
  else window.addEventListener('load', idle, { once: true })
}
